import { render } from "./overlapping-package-deactivation-modal.vue?vue&type=template&id=f0671bf7"
import script from "./overlapping-package-deactivation-modal.vue?vue&type=script&lang=js"
export * from "./overlapping-package-deactivation-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__